
import api from "../utils/axios";

export async function getWallet() {
  try {
    const res = await api.get(`/auth/wallet`);
    return res.data.wallet;
  } catch (error) {
    console.error("Failed to load wallet:", error);
    throw error;
  }
}

export async function convertScoreToWallet(points) {
  try {
    const response = await api.post("/auth/wallet/convert-score", {
      points,
    });

    return response.data;
  } catch (error) {
    console.error("Failed to Send wallet:", error);
    throw error;
  }
}
